import { useNavigate } from "react-router-dom";
import { fmtMoney } from "@/lib/api";
import { Building2, ArrowRight, Hourglass, CheckCircle2 } from "lucide-react";

export const vacancyTone = (days) => (days >= 30 ? "text-rose-700 bg-rose-50 border-rose-100" : days >= 14 ? "text-amber-700 bg-amber-50 border-amber-100" : "text-slate-700 bg-slate-50 border-slate-200");

export function VacancyPanel({ vacancies = [], total = 0 }) {
  const navigate = useNavigate();
  return (
    <div className="rounded-2xl border border-slate-200 bg-white p-6" data-testid="vacancy-panel">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2"><Hourglass className="h-5 w-5 text-rose-600" /><h2 className="font-display font-bold text-lg text-slate-900">Vacant houses</h2></div>
        {vacancies.length > 0 && <span className="text-xs font-semibold text-rose-700" data-testid="vacancy-total-lost">~{fmtMoney(total)} rent lost</span>}
      </div>
      {vacancies.length === 0 ? (
        <div className="flex items-center gap-2 text-sm text-emerald-700 py-6 justify-center" data-testid="vacancy-empty"><CheckCircle2 className="h-4 w-4" /> Every house is occupied.</div>
      ) : (
        <div className="space-y-2.5">
          {vacancies.map((v) => (
            <button key={v.property_id} type="button" onClick={() => navigate("/properties")} data-testid={`vacancy-row-${v.property_id}`}
              className="w-full flex items-center gap-3 rounded-xl border border-slate-200 p-3 text-left hover:border-primary hover:bg-accent/30 transition">
              <span className="h-9 w-9 rounded-lg bg-slate-100 text-slate-500 flex items-center justify-center shrink-0"><Building2 className="h-4 w-4" /></span>
              <span className="flex-1 min-w-0">
                <span className="block text-sm font-semibold text-slate-800 truncate">{v.name}</span>
                <span className="block text-xs text-slate-500 truncate">
                  {v.rent_lost != null ? <>~{fmtMoney(v.rent_lost)} lost · {fmtMoney(v.monthly_rent)}/mo {v.rent_source === "target" ? "target" : "last lease"}</> : "Set a target rent to estimate lost income"}
                </span>
              </span>
              <span className={`rounded-full border px-2.5 py-1 text-xs font-bold whitespace-nowrap ${vacancyTone(v.days)}`}>{v.days}d vacant</span>
              <ArrowRight className="h-4 w-4 text-slate-400 shrink-0" />
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
